module.exports = __webpack_public_path__ + "img/fluteMaster.d76dc6e6.png";